import request from '@/utils/request'
import { BASE_API } from '@/utils/consts'
import { func } from 'prop-types'

export function addOrder(data) {
  return request(`${BASE_API}/order/create`, {
    method: 'POST',
    data
  })
}

export function updateOrder(data) {
  return request(`${BASE_API}/order/update`, {
    method: 'PUT',
    data
  })
}
//查询诊所相关角色人员
export function queryClinicEmployeeByRole(data) {
  return request(`${BASE_API}/employee/list_by_role`, {
    data
  })
}
// 获取所有的客户状态列表
export function queryCustomerStatusList(data) {
  return request(`${BASE_API}/customer/status/list`, {
    method: 'POST',
    data
  })
}
export function queryOrderInfo(orderId) {
  return request(`${BASE_API}/order/show/${orderId}`)
}

export function queryOrders(data) {
  return request(`${BASE_API}/order/list`, {
    method: 'POST',
    data
  })
}
export function queryDelOrders(data) {
  return request(`${BASE_API}/order/deleted/list`, {
    method: 'POST',
    data
  })
}

// 根据客户id查询订单
export function queryCustomsOrders(data) {
  return request(`${BASE_API}/order/list_by/${data.customerId}`, {
    data: {
      pageNo: data.pageNo,
      pageSize: data.pageSize
    }
  })
}

export function deleteOrder(data) {
  return request(`${BASE_API}/order/delete/${data.id}`, {
    method: 'DELETE'
  })
}

// 提交订单
export function submitOrder(data) {
  return request(`${BASE_API}/order/submit`, {
    method: 'PUT',
    data
  })
}

// 取消订单
export function cancelOrder(id) {
  return request(`${BASE_API}/order/cancel`, {
    method: 'put',
    data: { id }
  })
}

// 获取订单下的预约列表
export function orderReserve(data) {
  return request(`${BASE_API}/reservation/list_by_order_id/${data.id}`, {
    data: {
      pageNo: data.pageNo,
      pageSize: data.pageSize
    }
  })
}

// 获取订单待预约明细列表
export function orderReservations(data) {
  return request(`${BASE_API}/reservation/to_be_reservation/${data.id}`, {
    data: {
      pageNo: 1,
      pageSize: 1000
    }
  })
}

// 查询诊所角色为心理顾问的员工列表
export function queryConsultantAll(data) {
  return request(`${BASE_API}/employee/list/consultant?clinicId=${data.clinicId}`)
}

// 根据客户id获取待预约明细列表
export function customerOrderReservations(data) {
  return request(`${BASE_API}/reservation/to_be_reservation/by_customer/${data.id}`, {
    data: {
      clinicId: data.clinicId,
      pageNo: 1,
      pageSize: 1000
    }
  })
}

// 根据任务id查询订单
export function queryTaskOrder(data) {
  return request(`${BASE_API}/order/list/reservation_item_order/${data.id}`)
}

// 查询订单物流待发货物明细
export function queryLogisticsAvailable(id) {
  return request(`${BASE_API}/logistics/available/${id}`)
}

// 模板列表
export function queryClinicCombo(data) {
  return request(`${BASE_API}/combo/list`, {
    method: 'POST',
    data
  })
}

// 查询订单剩余待收款金额
export function queryToPayAmount(data) {
  return request(`${BASE_API}/order/to_pay_amount/${data.id}`)
}

// 查询订单剩余应收金额
export function queryShowRemain(data) {
  // return request(`${BASE_API}/payment/showRemain?orderId=${data.id}`)
  return request(`${BASE_API}/payment/show_remain?orderId=${data.id}`)
}

//导出
export function exportExcel(data) {
  return request(`${BASE_API}/order/list/data_export`, { method: 'POST', data, responseType: 'blob', download: true })
}

//修改订单来源
export function updateOrderSource(data) {
  return request(`${BASE_API}/order/update_source`, { method: 'PUT', data })
}

//修改订单来源
export function updateAssistant(data) {
  return request(`${BASE_API}/order/update_assistant_psychologist`, { method: 'PUT', data })
}

// 检查预期冲突
export function checkReserveClash(data) {
  return request(`${BASE_API}/reservation/conflict`, { method: 'POST', data })
}
export function getReservedTimes(data) {
  return request(`${BASE_API}/reservation/conflict/time`, { method: 'POST', data })
}